module.exports = __webpack_public_path__ + "assets/5b61283d3593f375a636c99b55014a60.jpg";